import { useCallback } from "react";
import type { NavigateFunction } from "react-router-dom";

export interface IUseNavigateBackOrToPathProps {
  navigate: NavigateFunction;
}

export function useNavigateBackOrToPath({ navigate }: Readonly<IUseNavigateBackOrToPathProps>) {
  const navigateBackOrToPath = useCallback(
    function navigateBackOrToPath(path: string): void {
      if (window.history.length > 1) {
        navigate(-1);
      } else {
        navigate(path);
      }
    },
    [navigate]
  );

  return { navigateBackOrToPath };
}
